import { useTranslations } from 'next-intl';
import React from 'react';

import ListPlaceholder, { ListPlaceholderProps } from '@/components/ListPlaceholder';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

import { useProgramFilterContext } from '@/providers/ProgramFilterProvider';

const PlaceholderImage = loadAsset('/images/placeholders/im-emptyListPlaceholder.png');

type EventListPlaceholderProps = {
    hideImage?: boolean;
    ListPlaceholderProps?: ListPlaceholderProps;
};
function EventListPlaceholder(props: EventListPlaceholderProps): React.JSX.Element {
    const t = useTranslations();
    const { activeFiltersCount } = useProgramFilterContext();

    return (
        <ListPlaceholder
            {...props.ListPlaceholderProps}
            image={props.hideImage ? undefined : PlaceholderImage}
            title={t('program.no-showings-oh-no-placeholder')}
            text={
                activeFiltersCount
                    ? t('program.no-showings-with-selected-filters')
                    : t('program.no-showings-placeholder')
            }
        />
    );
}

export default EventListPlaceholder;
